import { css, keyframes } from 'styled-components';
import { getBaseTheme } from '@Themes';
const { spaces, colors } = getBaseTheme();

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

const morphGates = keyframes` 
  0% {
    opacity: 1;
  }
  100% {
    width: 100px;
    height: 134px;
    margin-left: -50px;
    opacity: 1;
  }
}`;

export default css`
    opacity: 1;
    display: flex;
    flex-grow: 20;
    flex-direction: column;

    &.fade-out {
        animation: ${fadeOut};
        animation-duration: 0.5s;
        animation-timing-function: ease;
        animation-fill-mode: forwards;
    }

    .analyze-document-top {
        position: relative;
        flex-grow: 3;

        &-init-step {
            width: 140px;
            height: 134px;
            position: absolute;
            left: 50%;
            bottom: 36%;
            margin-left: -70px;
            overflow: hidden;
            opacity: 0;
            background-color: #e8e1d9; /* beige300 */
            border: 2px solid #796f64; /* beige500 */

            &.morph-gates {
                animation: ${morphGates} 0.5s ease-in-out forwards;
            }
        }

        &-document-step {
            width: 140px;
            height: 134px;
            position: absolute;
            bottom: 36%;
            left: 50%;
            margin: 0 0 0px -70px;
            opacity: 0;
        }

        &-document-step,
        &-init-step {
            &.fade-in {
                animation: ${fadeIn};
                animation-duration: 0.5s;
                animation-timing-function: ease;
                animation-fill-mode: forwards;
            }
        }
    }

    .analyze-document-bottom {
        z-index: 1;
        flex-grow: 1;
        background-color: rgb(247, 246, 247);
        .divider {
            margin: 0 ${spaces.default.s} 0 ${spaces.default.s};
            background-color: ${colors.area.default.foregroundColor};
        }
    }
`;
